// Generated with util/create-component.js
import Link from './Link';

export default Link;
